var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"margin-setting-summary-pivot"}},[(_vm.partCost && _vm.costItemRecords && _vm.currency)?_c('CostSummaryPivot',{attrs:{"currency":_vm.currency,"data":_vm.costItemRecords,"partCost":_vm.partCost,"loading":_vm.loading}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }